(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["north-ouest-collection"]) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (root.dataset.magicReady) return;
    root.dataset.magicReady = 'true';
    root.classList.add('is-enhanced');
    const labels = JSON.parse(root.querySelector('[data-magic-labels]').textContent);
    const controller = new AbortController();
    const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: controller.signal });
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const tint = (title) => {
      const name = title.toLowerCase();
      if (name.includes('gold') || name.includes('rose')) return '#e7d9b9';
      if (name.includes('blue')) return '#c7dce2';
      if (name.includes('green')) return '#cedac8';
      if (name.includes('black') || name.includes('grey')) return '#d5d8d2';
      return '#e5e2d6';
    };
    const swapImage = (image, button, title) => {
      image.srcset = button.dataset.srcset;
      image.src = button.dataset.image;
      image.alt = title;
      if (!motion.matches && image.animate) image.animate([{ opacity: .35, translate: '0 4px' }, { opacity: 1, translate: '0 0' }], { duration: 330, easing: 'ease-out' });
    };
    const tilt = (surface, target, prefix, strength) => {
      let frame = 0;
      let position = null;
      listen(surface, 'pointermove', (event) => {
        if (!pointer.matches || motion.matches || event.pointerType === 'touch') return;
        const rect = surface.getBoundingClientRect();
        position = { x: (event.clientX - rect.left) / rect.width - .5, y: (event.clientY - rect.top) / rect.height - .5 };
        if (frame) return;
        frame = requestAnimationFrame(() => {
          target.style.setProperty(`--${prefix}-rx`, `${-position.y * strength}deg`);
          target.style.setProperty(`--${prefix}-ry`, `${position.x * strength}deg`);
          frame = 0;
        });
      });
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        target.style.setProperty(`--${prefix}-rx`, '0deg');
        target.style.setProperty(`--${prefix}-ry`, '0deg');
      };
      listen(surface, 'pointerleave', reset);
      listen(motion, 'change', reset);
      listen(controller.signal, 'abort', reset);
    };
    const heroStage = root.querySelector('[data-hero-stage]');
    if (heroStage) tilt(heroStage, root.querySelector('[data-hero-tilt]'), 'hero', 13);
    root.querySelectorAll('[data-hero-finish]').forEach((button) => listen(button, 'click', () => {
      root.querySelectorAll('[data-hero-finish]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      swapImage(root.querySelector('.nom-hero-watch'), button, button.dataset.title);
      root.querySelector('[data-hero-price]').textContent = button.dataset.price;
      root.querySelector('[data-hero-finish-label]').textContent = button.dataset.title;
      root.querySelector('[data-hero-link]').href = button.dataset.url;
    }));
    const base = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
    let cartQueue = Promise.resolve();
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const image = card.querySelector('.nom-card-image');
      const form = card.querySelector('[data-card-form]');
      const input = card.querySelector('[data-variant-input]');
      const nativeSelect = card.querySelector('.nom-native-variants select');
      input.disabled = false;
      if (nativeSelect) nativeSelect.disabled = true;
      const button = card.querySelector('[data-card-atc]');
      const status = card.querySelector('[data-card-status]');
      const swatches = [...card.querySelectorAll('[data-variant-button]')];
      let available = !button.disabled;
      let pending = false;
      card.style.setProperty('--card-glow', tint(card.querySelector('[data-variant-label]').textContent));
      tilt(card.querySelector('[data-card-stage]'), card, 'card', 9);
      swatches.forEach((swatch) => listen(swatch, 'click', () => {
        if (pending) return;
        input.value = swatch.dataset.id;
        if (nativeSelect) nativeSelect.value = input.value;
        available = swatch.dataset.available === 'true';
        card.style.setProperty('--card-glow', tint(swatch.dataset.title));
        swatches.forEach((item) => item.setAttribute('aria-pressed', String(item === swatch)));
        swapImage(image, swatch, card.querySelector('h3').textContent + ' — ' + swatch.dataset.title);
        card.querySelector('[data-card-price]').textContent = swatch.dataset.price;
        const compare = card.querySelector('[data-card-compare]');
        compare.textContent = swatch.dataset.compare;
        compare.hidden = swatch.dataset.sale !== 'true';
        card.querySelector('[data-variant-label]').textContent = swatch.dataset.title;
        card.querySelectorAll('[data-product-link]').forEach((link) => link.href = swatch.dataset.url);
        button.disabled = !available;
        card.querySelector('[data-atc-label]').textContent = available ? labels.add : labels.sold_out;
        status.hidden = true;
      }));
      listen(form, 'submit', (event) => {
        event.preventDefault();
        if (pending || !available) return;
        pending = true;
        const variantId = input.value;
        card.classList.add('is-loading');
        button.disabled = true;
        swatches.forEach((swatch) => swatch.disabled = true);
        card.querySelector('[data-atc-label]').textContent = labels.adding;
        status.hidden = true;
        const add = async () => {
          try {
            const response = await fetch(base + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || labels.error);
            let sections = data.sections;
            if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
              const url = new URL(location.href);
              url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
              try {
                const sectionsResponse = await fetch(url);
                if (sectionsResponse.ok) sections = await sectionsResponse.json();
              } catch {}
            }
            const drawer = document.querySelector('cart-drawer');
            let opened = false;
            if (drawer && typeof drawer.renderContents === 'function' && sections?.['cart-drawer'] && sections?.['cart-icon-bubble']) {
              try {
                drawer.setActiveElement?.(button);
                drawer.classList.remove('is-empty');
                drawer.renderContents({ id: data.items?.[0]?.id || variantId, sections });
                opened = true;
              } catch {}
            }
            status.classList.remove('is-error');
            status.textContent = labels.added;
            if (!opened) {
              const link = document.createElement('a');
              link.href = base + 'cart';
              link.textContent = labels.view_cart;
              status.append(' ', link);
            }
            status.hidden = false;
          } catch (error) {
            status.classList.add('is-error');
            status.textContent = error.message || labels.error;
            status.hidden = false;
          } finally {
            pending = false;
            card.classList.remove('is-loading');
            button.disabled = !available;
            swatches.forEach((swatch) => swatch.disabled = false);
            card.querySelector('[data-atc-label]').textContent = available ? labels.add : labels.sold_out;
          }
        };
        cartQueue = cartQueue.then(add, add);
      });
    });
    let observer;
    if (!motion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('[data-product-card]').forEach((card) => observer.observe(card));
    }
    root.magicDestroy = () => { controller.abort(); observer?.disconnect(); delete root.dataset.magicReady; };
  };
  document.querySelectorAll('[data-north-magic]').forEach(initialise);
  if (!window.northMagicEvents) {
    window.northMagicEvents = true;
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-north-magic]').forEach(initialise));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-north-magic]').forEach((root) => root.magicDestroy?.()));
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["north-ouest-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (root.dataset.magicReady) return;
    root.dataset.magicReady = 'true';
    root.classList.add('is-enhanced');
    const labels = JSON.parse(root.querySelector('[data-magic-labels]').textContent);
    const controller = new AbortController();
    const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: controller.signal });
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const tint = (title) => {
      const name = title.toLowerCase();
      if (name.includes('gold') || name.includes('rose')) return '#e7d9b9';
      if (name.includes('blue')) return '#c7dce2';
      if (name.includes('green')) return '#cedac8';
      if (name.includes('black') || name.includes('grey')) return '#d5d8d2';
      return '#e5e2d6';
    };
    const swapImage = (image, button, title) => {
      image.srcset = button.dataset.srcset;
      image.src = button.dataset.image;
      image.alt = title;
      if (!motion.matches && image.animate) image.animate([{ opacity: .35, translate: '0 4px' }, { opacity: 1, translate: '0 0' }], { duration: 330, easing: 'ease-out' });
    };
    const tilt = (surface, target, prefix, strength) => {
      let frame = 0;
      let position = null;
      listen(surface, 'pointermove', (event) => {
        if (!pointer.matches || motion.matches || event.pointerType === 'touch') return;
        const rect = surface.getBoundingClientRect();
        position = { x: (event.clientX - rect.left) / rect.width - .5, y: (event.clientY - rect.top) / rect.height - .5 };
        if (frame) return;
        frame = requestAnimationFrame(() => {
          target.style.setProperty(`--${prefix}-rx`, `${-position.y * strength}deg`);
          target.style.setProperty(`--${prefix}-ry`, `${position.x * strength}deg`);
          frame = 0;
        });
      });
      const reset = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        target.style.setProperty(`--${prefix}-rx`, '0deg');
        target.style.setProperty(`--${prefix}-ry`, '0deg');
      };
      listen(surface, 'pointerleave', reset);
      listen(motion, 'change', reset);
      listen(controller.signal, 'abort', reset);
    };
    const heroStage = root.querySelector('[data-hero-stage]');
    if (heroStage) tilt(heroStage, root.querySelector('[data-hero-tilt]'), 'hero', 13);
    root.querySelectorAll('[data-hero-finish]').forEach((button) => listen(button, 'click', () => {
      root.querySelectorAll('[data-hero-finish]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      swapImage(root.querySelector('.nom-hero-watch'), button, button.dataset.title);
      root.querySelector('[data-hero-price]').textContent = button.dataset.price;
      root.querySelector('[data-hero-finish-label]').textContent = button.dataset.title;
      root.querySelector('[data-hero-link]').href = button.dataset.url;
    }));
    const base = root.dataset.root.endsWith('/') ? root.dataset.root : root.dataset.root + '/';
    let cartQueue = Promise.resolve();
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const image = card.querySelector('.nom-card-image');
      const form = card.querySelector('[data-card-form]');
      const input = card.querySelector('[data-variant-input]');
      const nativeSelect = card.querySelector('.nom-native-variants select');
      input.disabled = false;
      if (nativeSelect) nativeSelect.disabled = true;
      const button = card.querySelector('[data-card-atc]');
      const status = card.querySelector('[data-card-status]');
      const swatches = [...card.querySelectorAll('[data-variant-button]')];
      let available = !button.disabled;
      let pending = false;
      card.style.setProperty('--card-glow', tint(card.querySelector('[data-variant-label]').textContent));
      tilt(card.querySelector('[data-card-stage]'), card, 'card', 9);
      swatches.forEach((swatch) => listen(swatch, 'click', () => {
        if (pending) return;
        input.value = swatch.dataset.id;
        if (nativeSelect) nativeSelect.value = input.value;
        available = swatch.dataset.available === 'true';
        card.style.setProperty('--card-glow', tint(swatch.dataset.title));
        swatches.forEach((item) => item.setAttribute('aria-pressed', String(item === swatch)));
        swapImage(image, swatch, card.querySelector('h3').textContent + ' — ' + swatch.dataset.title);
        card.querySelector('[data-card-price]').textContent = swatch.dataset.price;
        const compare = card.querySelector('[data-card-compare]');
        compare.textContent = swatch.dataset.compare;
        compare.hidden = swatch.dataset.sale !== 'true';
        card.querySelector('[data-variant-label]').textContent = swatch.dataset.title;
        card.querySelectorAll('[data-product-link]').forEach((link) => link.href = swatch.dataset.url);
        button.disabled = !available;
        card.querySelector('[data-atc-label]').textContent = available ? labels.add : labels.sold_out;
        status.hidden = true;
      }));
      listen(form, 'submit', (event) => {
        event.preventDefault();
        if (pending || !available) return;
        pending = true;
        const variantId = input.value;
        card.classList.add('is-loading');
        button.disabled = true;
        swatches.forEach((swatch) => swatch.disabled = true);
        card.querySelector('[data-atc-label]').textContent = labels.adding;
        status.hidden = true;
        const add = async () => {
          try {
            const response = await fetch(base + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || labels.error);
            let sections = data.sections;
            if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
              const url = new URL(location.href);
              url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
              try {
                const sectionsResponse = await fetch(url);
                if (sectionsResponse.ok) sections = await sectionsResponse.json();
              } catch {}
            }
            const drawer = document.querySelector('cart-drawer');
            let opened = false;
            if (drawer && typeof drawer.renderContents === 'function' && sections?.['cart-drawer'] && sections?.['cart-icon-bubble']) {
              try {
                drawer.setActiveElement?.(button);
                drawer.classList.remove('is-empty');
                drawer.renderContents({ id: data.items?.[0]?.id || variantId, sections });
                opened = true;
              } catch {}
            }
            status.classList.remove('is-error');
            status.textContent = labels.added;
            if (!opened) {
              const link = document.createElement('a');
              link.href = base + 'cart';
              link.textContent = labels.view_cart;
              status.append(' ', link);
            }
            status.hidden = false;
          } catch (error) {
            status.classList.add('is-error');
            status.textContent = error.message || labels.error;
            status.hidden = false;
          } finally {
            pending = false;
            card.classList.remove('is-loading');
            button.disabled = !available;
            swatches.forEach((swatch) => swatch.disabled = false);
            card.querySelector('[data-atc-label]').textContent = available ? labels.add : labels.sold_out;
          }
        };
        cartQueue = cartQueue.then(add, add);
      });
    });
    let observer;
    if (!motion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('[data-product-card]').forEach((card) => observer.observe(card));
    }
    root.magicDestroy = () => { controller.abort(); observer?.disconnect(); delete root.dataset.magicReady; };
  };
  document.querySelectorAll('[data-north-magic]').forEach(initialise);
  if (!window.northMagicEvents) {
    window.northMagicEvents = true;
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-north-magic]').forEach(initialise));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-north-magic]').forEach((root) => root.magicDestroy?.()));
  }
})();


  } catch(e) { console.error(e); }
})();
})();
